import React from "react";
import { Helmet } from "react-helmet";

function Money_Transfer_Seo() {
  return (
    <div>
      <Helmet>
        <title>
          Money Transfer to Nigeria Instantly with IFEPay – Fast & Secure
          Remittances
        </title>
        <meta
          name="description"
          content="Send money to Nigeria instantly with IFEPay. Enjoy fast, secure, and low-cost money transfers to Nigeria. Sign up now for seamless international remittances at competitive exchange rates."
        />
        <meta
          property="og:title"
          content="Money Transfer to Nigeria Instantly with IFEPay – Fast & Secure Remittances"
        />
        <meta
          property="og:description"
          content="Send money to Nigeria instantly with IFEPay. Enjoy fast, secure, and low-cost money transfers to Nigeria. Sign up now for seamless international remittances at competitive exchange rates."
        />
        <meta
          property="og:image"
          content="https://ifepay.co.uk/assets/images/logo.png"
        />{" "}
        {/* Replace with actual image URL */}
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://ifepay.co.uk/money-transfer" />
      </Helmet>
    </div>
  );
}

export default Money_Transfer_Seo;
